/*eslint-disable*/
import React, { useState } from 'react'
import { Button, Icon, Modal } from 'semantic-ui-react'

import DeleteAxios from '../axiosComponent/delete'
import DeleteModal from '../deleteComponent/deleteModal'
import EditModal from '../commonComponent/editModal'
import FormikEditCondition from './editCondition'

function ApprovalActionButton(props) {
    const [editModal, setEditModal] = useState(false)
    const [openBox, setopenBox] = useState(false)
    const [success, setsuccess] = useState(false)
    let handleEditClose = () => {
        setEditModal(false)
    }
    let handleClose = () => {
        setopenBox(false)
    }
    let handleDelete = () => {
        setsuccess(true)
        let id = props.data.id
        DeleteAxios({
            url: 'approvalcondition/delete',
            deleteItems: {
                jbConditionId: id
            },
            deleted: (data) => {
                if (data && data.status === 1) {
                    setTimeout(() => {
                        setsuccess(false)
                        props.agGridReact.props.reload(true)
                    }, 500);
                }
            }
        })

    }
    let handleOpenEdit = (e) => {
        setEditModal(true)
    }
    let handleOpenDelete = (e) => {
        setopenBox(true)
    }
    return (
        <>
            <Button disabled={props.data && props.data.customerNo === 0 ? true : false} onClick={handleOpenEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button>
            <Button disabled={props.data && props.data.customerNo === 0 ? true : false} onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button>
            <DeleteModal isloading={success} open={openBox} onClose={handleClose} handleDelete={handleDelete} />
            <EditModal size="tiny" open={editModal} onClose={handleEditClose}>
                <Modal.Header>Edit Approval Condition </Modal.Header>
                <FormikEditCondition
                    jbConditionId={props.data && props.data.id} jobCardTypeId={props.data && props.data.typeId}
                    conditionId={props.data && props.data.condId}
                    roleId={props.data && props.data.uroleId}
                    handleClose={handleEditClose}
                    jobcardType={props.data && props.data.type}
                    conditionName={props.data && props.data.condition} startValue={props.data && props.data.svalue} endValue={props.data && props.data.evalue}
                    role={props.data && props.data.urole}
                />
            </EditModal>
        </>
    )
}

export default ApprovalActionButton
